import type React from 'react';

import { useGetUser, useGetLists } from '@vlabs/api/artemy/client';
import type { UserId } from '@vlabs/api/artemy/model';

import { useUserListListTranslation } from './i18n';
import { UserList } from '../../../entities/lists/@x/users';
import { FoldableEntity } from '../../../shared/ui/foldable-entity';

interface UserListListProps {
  userId: UserId;
}

function UserListList({
  userId,
}: UserListListProps): React.JSX.Element {
  const { t } = useUserListListTranslation();
  const { data: user } = useGetUser(userId);
  const { data: lists } = useGetLists({ owner_department_ids: user?.department_ids }, {
    query: {
      enabled: (user?.department_ids?.length ?? 0) > 0,
    },
  });

  return (
    <FoldableEntity heading={t('title')}>
      {lists?.lists.map((list) => (
        <UserList
          key={list.list_id}
          listId={list.list_id}
        />
      ))}
    </FoldableEntity>
  );
}

export { UserListList };
